import { Conditional } from '@angular/compiler';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ClosingYearDisplayMessages } from 'src/app/finance/constants/closing-year.constant';
import { LOCK_MODULES } from 'src/app/finance/constants/constants';
import { ClosingYearService } from 'src/app/finance/periods/service/closing-year.service';

@Component({
  selector: 'app-closing-statement-validation',
  templateUrl: './closing-statement-validation.component.html',
  styleUrl: './closing-statement-validation.component.scss'
})
export class ClosingStatementValidationComponent implements OnChanges {
  @Input() isClosingDate: any;
  @Input() moduleName: string = '';
  @Output() isClosingStatementDate = new EventEmitter<any>();

  closingStatement: any;
  statementMessege: string = "";
  constructor(private closingYearService: ClosingYearService,) { }
  ngOnChanges(changes: SimpleChanges): void {
    if ((changes.isClosingDate && changes.isClosingDate.currentValue) || (changes.moduleName && changes.moduleName.currentValue)) {
      this.checkIsclosingDate(this.isClosingDate)
    }

  }

  getLockType(moduleName: any): string | undefined {
    for (const [lockType, modules] of Object.entries(LOCK_MODULES)) {
      if (modules?.includes(moduleName)) {
        return lockType;
      }
    }
    return undefined;
  }

  checkIsclosingDate(date) {
    if (!date) {
      return null; // If input is null or undefined, return null
    }
    if (typeof date === 'string') {
      const parsedDate = new Date(date);
      date = isNaN(parsedDate.getTime()) ? null : parsedDate; // Check for invalid date
    }
    const year = date?.getFullYear();
    const monthId = date?.getMonth() + 1;
    if (year > 0 && monthId > 0) {
      this.closingYearService.getClosingStatement(year, monthId).subscribe(resp => {
        this.closingStatement = this.closingYearService.prepareClosingYearsLock(resp);
        const lockType = this.getLockType(this.moduleName);
        if (
          (lockType === 'excludeOthers' && this.closingStatement && !this.closingStatement[lockType]) ||
          (lockType !== 'excludeOthers' && this.closingStatement && this.closingStatement[lockType])
        ) {
          this.statementMessege = ClosingYearDisplayMessages.lockMessage;
        } else {
          this.statementMessege = '';
        }
        this.isClosingStatementDate.emit(this.statementMessege);
      })
    }
  }
}
